export const PRODUCT_ID_DIGITAL_DOWNLOAD = -11;
export const PRODUCT_ID_OPTIONAL_DONATION = -22;